import { FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION } from '@constants/transactions';

const selectSoftDescriptorLastMovements = [
  {
    id: null,
    name: 'Todos los detalles',
  },
  {
    id: FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.RETIRO,
    name: 'Retiro de fondos',
  },
  {
    id: FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.TRANSFERENCIA,
    name: 'Transferencia diferida',
  },
  {
    id: FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION.ORDEN,
    name: 'Orden de pago',
  },
];

export default selectSoftDescriptorLastMovements;
